(function() {
    'use strict';

    angular
        .module('elogbooks.user.meter-types')
        .controller('MeterUnitAddEditController', MeterUnitAddEditController);

    MeterUnitAddEditController.$inject = ['$state', '$translate', 'apiClient', 'confirmationModal', 'messenger', 'meterUnitResponse', 'meterUnitsCollectionResponse', 'requestDataFactory'];
    function MeterUnitAddEditController($state, $translate, apiClient, confirmationModal, messenger, meterUnitResponse, meterUnitsCollectionResponse, requestDataFactory) {
        var vm = this;
        vm.meterUnit = meterUnitResponse;
        vm.data = requestDataFactory.createRequest(meterUnitResponse);
        vm.meterUnitsCollectionResponse = meterUnitsCollectionResponse;

        vm.create = createAction;
        vm.update = updateAction;
        vm.delete = deleteAction;

        vm.status = [
            {value: true, title: $translate.instant('STATUS_ACTIVE')},
            {value: false, title: $translate.instant('STATUS_INACTIVE')}
        ];

        function updateAction() {
            return apiClient.update(vm.meterUnit.getLink('edit'), vm.data).then(function(response) {
                if (response) {
                    $state.go('^', {}, {reload: $state.get('^.^.^')}).then(function() {
                        messenger.success('METER_UNIT_UPDATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function createAction() {
            return apiClient.create(vm.meterUnitsCollectionResponse.getLink('create'), vm.data).then(function(response) {
                if (response) {
                    $state.go('^.details.info', {resource: response.getLink('self').encode()}, { reload: $state.current.parent }).then(function() {
                        messenger.success('METER_UNIT_CREATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function deleteAction() {
            return confirmationModal.open().result.then(function(response) {
                if (response.result) {
                     apiClient.delete(vm.meterUnit.getLink('delete')).then(function(isSuccess) {
                        if (isSuccess) {
                            $state.go('^.^.^', {}, {reload: $state.get('^.^.^')}).then(function(){
                                messenger.success('METER_UNIT_DELETED');
                            });
                        } else {
                            messenger.error('REQUEST_ERROR');
                        }
                    });
                }
            });
        }
    }
})();
